import React from 'react';
import { useTheme, withStyles } from '@material-ui/core';
import { Stack, Typography } from '@mui/material';
import styles from './styles';
import IconButton from '../../../Buttons/IconButton/IconButton';
import MaterialIcon from '../../../../Venti-UI-Kit/VIcon/MaterialIcon';
import VImageUploader from '../../../../Venti-UI-Kit/VImageUploader/VImageUploader';

const DraggableEventListItem = ({
  classes,
  event,
  onRemoveEvent,
  hasImage = false,
  setEventImage,
}) => {
  const { name, id, promoImg, image } = event;
  const theme = useTheme();

  return (
    <Stack direction="row" className={classes.draggableItemContainer}>
      <Stack direction="row" alignItems="center" gap={1}>
        {hasImage
          ? image && <img src={image} className={classes.image} alt={name} />
          : promoImg && <img src={promoImg} className={classes.image} alt={name} />}
        <Typography>{name}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="center" alignItems="center" gap={1}>
        {hasImage && (
          <VImageUploader
            title="Imagen del evento"
            required
            name="image"
            width={200}
            height={150}
            imageHeight={1200}
            imageWidth={963}
            initialImageSrc={image}
            onChange={({ target: { value } }) => {
              setEventImage(id, value);
            }}
          />
        )}
        <IconButton
          Icon={<MaterialIcon name="delete" color={theme.palette.error.main} />}
          onClick={() => onRemoveEvent(id)}
          variant="outlined"
          color={theme.palette.error.main}
        />
      </Stack>
    </Stack>
  );
};

export default withStyles(styles)(DraggableEventListItem);
